<template>
  <ul class="vuejs-countdown">
    <h3>Expires in</h3>
    <li v-if="days > 0">
      <p class="digit">{{ days | twoDigits }}</p>
      <p class="text">{{ days > 1 ? 'days' : 'day' }}</p>
    </li>
    <li>
      <p class="digit">{{ hours | twoDigits }}</p>
      <p class="text">{{ hours > 1 ? 'hours' : 'hour' }}</p>
    </li>
    <li>
      <p class="digit">{{ minutes | twoDigits }}</p>
      <p class="text">min</p>
    </li>
    <li>
      <p class="digit">{{ seconds | twoDigits }}</p>
      <p class="text">Sec</p>
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'

let interval = null
export default {
  name: 'CountdownClient',
  props: {
    deadline: {
      type: String
    },
    talent: {
      type: Object
    }
  },
  data () {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0
    }
  },
  created () {
    if (!this.deadline) {
      throw new Error("Missing prop 'deadline'")
    }
    let endTime = this.deadline
    this.date = Math.trunc(Date.parse(endTime.replace(/-/g, '/')) / 1000)
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline'")
    }
    interval = setInterval(() => {
      this.now = Math.trunc((new Date()).getTime() / 1000)
    }, 1000)
  },
  computed: {
    seconds () {
      return Math.trunc(this.diff) % 60
    },
    minutes () {
      return Math.trunc(this.diff / 60) % 60
    },
    hours () {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days () {
      return Math.trunc(this.diff / 60 / 60 / 24)
    },
    stateTalentResponseExpired: {
      get () {
        return this.talent.response.expired
      },

      set () {
        this.setRequestTalentProperty({ id: this.talent.id, property: 'response.expired', value: true })
      }
    }
  },
  watch: {
    now () {
      this.diff = this.date - this.now
      if (this.diff <= 0) {
        this.diff = 0
        // Remove interval
        clearInterval(interval)
        if (!this.stateTalentResponseExpired) {
          this.setTalentExpiredTrue()
        }
      }
    }
  },
  methods: {
    ...mapActions('booking/request', ['setRequestTalentProperty']),

    setTalentExpiredTrue () {
      // TODO Run an api call to expire the talent in the database
      this.stateTalentResponseExpired = true
    }
  },
  filters: {
    twoDigits (value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  },
  destroyed () {
    clearInterval(interval)
  }
}
</script>
<style>
.vuejs-countdown {
  padding: 0;
  margin: 0;
  padding-left: 0px !important;
}
.vuejs-countdown li {
  display: inline-block;
  margin: 0 4px;
  text-align: center;
  position: relative;
  padding-left: 0px !important;
}
.vuejs-countdown li p {
  margin: 0;
}
.vuejs-countdown li:first-of-type {
  margin-left: 0;
}
.vuejs-countdown li:last-of-type {
  margin-right: 0;
}
.vuejs-countdown li:last-of-type:after {
  content: "";
}

.vuejs-countdown h3 {
  text-align: left !important;
  color: grey !important;
  padding: 0px !important;
  font-size: 12px !important;
}
@media (min-width: 993px) {
  .vuejs-countdown .digit {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 0;
  }
}
@media (max-width: 992px) {
  .vuejs-countdown .digit {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    margin-bottom: 0;
  }
  .vuejs-countdown h3 {
    padding-left: 5px !important;
  }
}

.vuejs-countdown .text {
  text-transform: uppercase;
  margin-bottom: 0;
  font-size: 10px;
}
</style>
